<p-dialog [visible]="visible" (visibleChange)="visibleChange.emit($event)" [modal]="true" [dismissableMask]="true"
  [draggable]="false" [resizable]="false" [header]="'keyboardShortcuts.title' | translate"
  styleClass="keyboard-shortcuts-dialog" [style]="{ width: 'min(30rem, calc(100vw - 2rem))' }">
  <section *ngFor="let section of sections; trackBy: trackByLabel" class="keyboard-shortcuts-section">
    <h3 class="keyboard-shortcuts-heading">{{ section.title | translate }}</h3>
    <dl>
      <div *ngFor="let row of section.rows; trackBy: trackByLabel" class="keyboard-shortcuts-row">
        <dt>{{ row.label | translate }}</dt>
        <dd>
          <kbd *ngFor="let key of row.keys">{{ key }}</kbd>
        </dd>
      </div>
    </dl>
  </section>
</p-dialog>
